/**
 * Api.Constant.ts
 * This Component is used to define endpoint commonly.
 */

export const ApiSignin = "/Auth/SignIn";

// Configuration End Points
export const GetCountryList = "/Config/GetCountryList";
export const GetStateList = "/Config/GetStateList";
export const GetDistrictList = "/Config/GetDistrictList";
export const GetConfigParamDataList = "/Config/GetConfigParamDataList";
export const GetConfigGroups = "/Config/GetConfigGroups";
export const AddEditConfigGroup = "/Config/AddEditConfigGroup";
export const GetSpecificConfigGroup = "/Config/GetSpecificConfigGroup";
export const GetSpecificConfigParamData = "/Config/GetSpecificConfigParamData";
export const AddEditConfigInfo = "/Config/AddEditConfigInfo";
export const GetMenuHierarchyList = "/Config/GetMenuHierarchyList";
export const GetChunkAPICountDtl = "/Config/GetChunkAPICountDtl";
export const GetVersionInfo = "/Config/GetVersionInfo";

// USER MANAGEMENT
export const GetUserList = "/UserManagement/GetUserList";
export const AddEditUser = "/UserManagement/AddEditUser";
export const GetSpecificUserMasterData =
  "/UserManagement/GetSpecificUserMasterData";
export const GetRoleList = "/UserManagement/GetRoleList";
export const GetSpecificRoleInformation =
  "/UserManagement/GetSpecificRoleInformation";
export const AddOrUpdateRoleInformation =
  "/UserManagement/AddOrUpdateRoleInformation";
export const ValidateOTP = "/UserManagement/ValidateOtp";
export const ChangePassword = "/UserManagement/ChangePassword";
export const GenerateOtp = "/UserManagement/GenerateOtp";
export const ValidateOTPOpen = "/OpenPage/ValidateOtp";
export const ChangePasswordOpen = "/OpenPage/ChangePassword";
export const GenerateOtpOpen = "/OpenPage/GenerateOtp";

// Customer Module End Points
export const GetCustomerList = "/Project/GetCustomerList";
export const AddEditCustomer = "/Project/AddEditCustomer";
export const GetSpecificCustomerData = "/Project/GetSpecificCustomerData";
export const AddEditCustomerPartnerMapping =
  "/Project/AddEditCustomerPartnerMapping";

// Dealer Module End Points
export const GetDealerList = "/Project/GetDealerList";
export const GetDealerPartnerMappingList =
  "/Project/GetDealerPartnerMappingList";

export const GetSpecificDealerMasterData =
  "/Project/GetSpecificDealerMasterData";
export const GetDealerMasterList = "/Project/GetDealerMasterList";
export const AddEditDealer = "/Project/AddEditDealer";
export const GetSpecificDealerData = "/Project/GetSpecificDealerData";
export const AddEditDealerPartnerMapping =
  "/Project/AddEditDealerPartnerMapping";

// Service Partner End Points
export const AddEditServicePartner = "/Project/AddEditServicePartner";
export const GetServicePartnerList = "/Project/GetServicePartnerList";
export const GetCustMappedPartnerList = "/Project/GetCustMappedPartnerList";
export const GetSpecificServicePartner = "/Project/GetSpecificServicePartner";

// Bulk Upload End Points
export const ImportDealerList = "/BulkUpload/ImportDealerList";
export const ImportTicketList = "/BulkUpload/ImportTicketList";
export const ImportEngineerList = "/BulkUpload/ImportEngineerList";
export const SaveBulkDealerList = "/BulkUpload/SaveBulkDealerList";
export const ApproveADL = "/BulkUpload/ApproveADL";
export const GetBulkUploadSample = "/Reports/GetBulkUploadSample";
export const GetADLErrorReport = "/Reports/GetADLErrorReport";
export const GetTicketCount = "/Reports/GetTicketCount";
export const GetTicketTypeCount = "/Reports/GetTicketTypeCount";
export const GetTicketUploadSample = "/Reports/GetTicketUploadSample";
export const GetEngineerUploadSample = "/Reports/GetEngineerUploadSample";
export const GetUploadedADLData = "/Reports/GetUploadedADLData";
export const GetTicketBulkDataReport = "/Reports/GetTicketBulkDataReport";
export const GetEnggBulkDataReport = "/Reports/GetEnggBulkDataReport";
export const GetServiceInstallationReport =
  "/Reports/GetServiceInstallationReport";
export const GetDealerActiveAssetReport = "/Reports/GetDealerActiveAssetReport";
export const GetYearlyDealerReport = "/Reports/GetYearlyDealerReport";
export const GetSLAReport = "/Reports/GetSLAReport";
export const GetTicketProgressReport = "/Reports/GetTicketProgressReport";
// Ticket Module End Points
export const AddEditTicket = "/Ticket/AddEditTicket";
export const GetTicketList = "/Ticket/GetTicketList";
export const GetSpecificTicket = "/Ticket/GetSpecificTicket";
export const GetSpecificTicketAMCApproval =
  "/Ticket/GetSpecificTicketAMCApproval";
export const AddEditTicketAMCApproval = "/Ticket/AddEditTicketAMCApproval";
export const ReassignTicket = "/Ticket/ReassignTicket";
export const GetSpareDepHistory = "/Ticket/GetSpareDepHistory";
export const AddEditSpareDependency = "/Ticket/AddEditSpareDependency";
export const DeleteTicket = "/Ticket/DeleteTicket";

// Product Module End Points
export const GetProductList = "/Project/GetProductList";
export const AddEditProduct = "/Product/AddEditProduct";
export const GetSpecificProductList = "/Product/GetSpecificProductList";

// Holiday List End Points
export const GetHolidayList = "/Config/GetAllCalendarEvents";
export const AddEditCalendarEvent = "/Config/AddEditCalendarEvent";
export const UpdateChunkAPICount = "/Config/UpdateChunkAPICount";

// Config-state End Points
export const AddEditState = "/Config/AddEditState";
export const AddDistrict = "/Config/AddDistrict";
export const UpdateDistrict = "/Config/UpdateDistrict";
export const GetGroupById = "/Config/GetGroupById";
export const GetIssueCategoryList = "/Config/GetIssueCategoryList";
export const AddEditIssueCategory = "/Config/AddEditIssueCategory";

// Config-spare End Points
export const GetSpareList = "/Product/GetSpareList";
export const AddEditSpare = "/Product/AddEditSpare";
export const AddEditSpareProduct = "/Product/AddEditSpareProduct";
export const GetSpecificSpare = "/Product/GetSpecificSpare";
export const GetSpareProductList = "/Product/GetSpareProductList";

// Logs End Points
export const GetAuditLogList = "/Config/GetAuditLogList";

//Dashboard End Points
export const GetDashboardTicketCount = "/Reports/GetDashboardTicketCount";
export const GetDashboardIssueCatData = "/Reports/GetDashboardIssueCatData";
export const GetDashboardSLAData = "/Reports/GetDashboardSLAData";
export const GetDashboardPartnerData = "/Reports/GetDashboardPartnerData";

// Reports End Points,
export const GetAMCSummaryReport = "/Reports/GetAMCSummaryReport";
export const AddEditReportData = "/Reports/AddEditReportData";
export const GetInstallationCostReport = "/Reports/GetInstallationCostReport";
export const GetReportLogsList = "/Reports/GetReportLogsList";
export const GetReportDataList = "/Reports/GetReportDataList";
export const AddEditReportSchedules = "/Reports/AddEditReportSchedules";
export const GetReportSchedulesList = "/Reports/GetReportScheduleList";
export const GetDashboardDailyTicketCount =
  "/Reports/GetDashboardDailyTicketCount";

// Product Rate Module End Points
export const GetCustomerAMCRateList = "/Product/GetCustomerAMCRateList";
export const GetPartnerRateList = "/Product/GetPartnerRateList";
export const AddEditCustomerAMCRate = "/Product/AddEditCustomerAMCRate";
export const AddEditServicePartnerRate = "/Product/AddEditServicePartnerRate";
